(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqaccordion"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFaqAccordion(root) {
    if (root.dataset.faqInitialized) return;
    root.dataset.faqInitialized = 'true';

    var allowMultiple = root.dataset.allowMultiple === 'true';
    var triggers = root.querySelectorAll('.faq-accordion__trigger');

    function getPanel(trigger) {
      return document.getElementById(trigger.getAttribute('aria-controls'));
    }

    function expand(trigger) {
      var panel = getPanel(trigger);
      if (!panel) return;
      trigger.setAttribute('aria-expanded', 'true');
      panel.style.height = panel.scrollHeight + 'px';

      function onEnd(e) {
        if (e.propertyName !== 'height') return;
        panel.style.height = 'auto';
        panel.removeEventListener('transitionend', onEnd);
      }
      panel.addEventListener('transitionend', onEnd);
    }

    function collapse(trigger) {
      var panel = getPanel(trigger);
      if (!panel) return;
      panel.style.height = panel.scrollHeight + 'px';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          panel.style.height = '0px';
        });
      });
      trigger.setAttribute('aria-expanded', 'false');
    }

    triggers.forEach(function (trigger) {
      var panel = getPanel(trigger);
      if (!panel) return;
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      panel.style.height = isOpen ? panel.scrollHeight + 'px' : '0px';

      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';

        if (!expanded && !allowMultiple) {
          triggers.forEach(function (other) {
            if (other !== trigger && other.getAttribute('aria-expanded') === 'true') {
              collapse(other);
            }
          });
        }

        expanded ? collapse(trigger) : expand(trigger);
      });
    });
  }

  document.querySelectorAll('[data-faq-accordion]').forEach(initFaqAccordion);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-faq-accordion]');
    if (root) initFaqAccordion(root);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var trigger = event.target.querySelector('.faq-accordion__trigger');
    if (trigger && trigger.getAttribute('aria-expanded') !== 'true') {
      trigger.click();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-overview"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousel(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-slide]'));
    if (slides.length < 2) return;

    var dotsWrap = root.querySelector('[data-carousel-dots]');
    var prevBtn = root.querySelector('[data-carousel-prev]');
    var nextBtn = root.querySelector('[data-carousel-next]');
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 6000;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = 0;
    var timer = null;

    slides.forEach(function (slide, idx) {
      if (dotsWrap) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'reviews-carousel__dot';
        dot.setAttribute('aria-label', 'Bewertung ' + (idx + 1));
        dot.addEventListener('click', function () { show(idx); restart(); });
        dotsWrap.appendChild(dot);
      }
    });

    function show(idx) {
      i = (idx + slides.length) % slides.length;
      slides.forEach(function (slide, idx2) {
        slide.classList.toggle('is-active', idx2 === i);
      });
      if (dotsWrap) {
        Array.prototype.forEach.call(dotsWrap.children, function (dot, idx2) {
          dot.setAttribute('aria-current', idx2 === i ? 'true' : 'false');
        });
      }
    }

    function restart() {
      if (timer) clearInterval(timer);
      if (!autoplay || reduceMotion) return;
      timer = setInterval(function () { show(i + 1); }, speed);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { show(i - 1); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(i + 1); restart(); });
    root.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    root.addEventListener('mouseleave', restart);
    root.addEventListener('focusin', function () { if (timer) clearInterval(timer); });
    root.addEventListener('focusout', restart);

    show(0);
    restart();
  }

  document.querySelectorAll('[data-reviews-carousel]').forEach(initCarousel);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-reviews-carousel]');
    if (root) initCarousel(root);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
